var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppliedCoupon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#0DA500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11446_39764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68753 8.82109L4.1694 7.30297C3.99878 7.13234 3.72315 7.13234 3.55253 7.30297C3.3819 7.47359 3.3819 7.74922 3.55253 7.91984L5.38128 9.74859C5.5519 9.91922 5.82753 9.91922 5.99815 9.74859L10.6269 5.11984C10.7975 4.94922 10.7975 4.67359 10.6269 4.50297C10.4563 4.33234 10.1807 4.33234 10.01 4.50297L5.68753 8.82109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11446_39764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(1.75 1.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedCoupon);
export default __webpack_public_path__ + "static/media/applied-coupon.99b29ba4e2509601f0f08331ff124751.svg";
export { ForwardRef as ReactComponent };